/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

require('whatwg-fetch');

const React = require('react');
const { ThemeProvider } = require('react-jss');

exports.shouldUpdateScroll = args => {
  return false;
};

// JSS setup, previously provided by gatsby-plugin-jss (see gatsby-ssr.js)
// eslint-disable-next-line react/prop-types
exports.wrapRootElement = ({ element }) =>
  React.createElement(ThemeProvider, { theme: {} }, element);

// Drop the server rendered JSS styles to avoid conflicts with the client ones
exports.onInitialClientRender = () => {
  const ssStyles = window.document.getElementById('server-side-jss');
  if (ssStyles && ssStyles.parentNode) {
    ssStyles.parentNode.removeChild(ssStyles);
  }
};

exports.onClientEntry = () => {
  if (typeof window !== 'undefined') {
    window.addEventListener('load', function () {
      // Hotjar
      if (!window.hj) {
        (function (h, o, t, j, a, r) {
          h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments); };
          h._hjSettings = { hjid: 2128548, hjsv: 6 };
          a = o.getElementsByTagName('head')[0];
          r = o.createElement('script');
          r.async = true;
          r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
          a.appendChild(r);
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
      }

      // Chat widget (sender) — correct support widget script (CSI-860)
      var actorId = '7426e0dd-bcc6-4ffa-b84c-268b093d7a5b';
      if (actorId && !window.ctrl) {
        window.ctrlSettings = { webWidget: { actorId: actorId } };
        window.ctrl = window.ctrl || function () {
          (window.ctrl.q = window.ctrl.q || []).push(arguments);
        };
        var script = document.createElement('script');
        script.async = true;
        script.src = 'https://mw-widget.simulator.company/shim.js';
        var parent = document.getElementsByTagName('script')[0].parentNode;
        parent.appendChild(script);
      }

      // WebMCP — expose site tools to AI agents via browser API (COR-12733)
      if ('modelContext' in navigator) {
        var wmcpScript = document.createElement('script');
        wmcpScript.src = '/webmcp-tools.js';
        document.head.appendChild(wmcpScript);
      }
    });
  }
};
